import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import { NameTypeEnum } from 'types/customer';
import FirstName from '../components/FirstName';
import LastName from '../components/LastName';
import { BaseRealNameInfoProps } from '../type';

const Common2: FC<BaseRealNameInfoProps> = ({ disabled }) => {
    return (
        <div>
            <FirstName disabled={disabled} />
            <LastName disabled={disabled} />
            <EasyField name="name_type" $defaultValue={NameTypeEnum.COMMON2} type="hidden" />
        </div>
    );
};

export default Common2;
